module.exports = __webpack_public_path__ + "media/images/icon/default/product-c99f82cc0c0ca02391dbae0cce8be695.png";